import {Button} from '@luminopia/react-toolbox/lib/button'
import CheckboxField, { IFieldProps } from 'core/components/form/checkbox-field'
import Form, {ITheme as IFormTheme} from 'core/components/form/Form'
import TextField, {ITextFieldProps, ITheme as ITextFieldTheme} from 'core/components/form/text-field'
import {createValidator, required, integer, email, npiValidator, minLength, match} from 'core/validation'
import * as React from 'react'
import {Field, FormProps, reduxForm, SubmitHandler} from 'redux-form'
import * as classNames from './PasswordReset.css'

export interface IFormFields {
  email: string
}

interface ITheme extends IFormTheme {
  button?: string
  textFieldTheme?: ITextFieldTheme
}

interface IProps extends FormProps<IFormFields, {}, {}> {
  theme?: ITheme
}

/**
 * Approval form intended for use with redux-form.
 */
class PasswordReset extends React.PureComponent<IProps, {}> {
  public render(): React.ReactElement<{}> {


    const { handleSubmit, pristine, submitting, error, theme = {} } = this.props
    const emailProps: ITextFieldProps = {
      label: 'Email',
      placeholder: 'Email',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }

    const formTheme: IFormTheme = {
      error: theme.error,
    }

    return (
      <Form onSubmit={handleSubmit} error={error} theme={formTheme}>
        <Field name='email' component={TextField} props={emailProps}/>
        <Button
          className={classNames.button}
          icon='check'
          // label='Reset Password'
          disabled={pristine || submitting}
          raised primary
          onClick={handleSubmit}
        >
        </Button>
      </Form>
    )
  }
}

export default PasswordReset

/**
 * Component factory for creating forms, intended for use with redux-form.
 *
 * @param formName key to where your form's state will be mounted under the redux-form reducer
 * @param onSubmit fn called when prop `handleSubmit` is fired
 */
export const resetFormFactory = (
  {
    formName,
    onSubmit,
  }: {
    formName: string,
    onSubmit: SubmitHandler<IFormFields, {}, {}>,
  },
) => {
  const initialValues: IFormFields = {
    email: '',
  }

  const formDecorator = reduxForm<IFormFields, {}, {}>({
    form: formName,
    initialValues,
    onSubmit,
    validate: createValidator({
      email: [required, email],
    }),
  })

  return formDecorator(PasswordReset)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/passwordReset/PasswordReset.tsx